import { languages } from "../constants/languages";
import { getResultSpotName } from "./GetResultSpotName";

export const getTeamName = (
  match,
  poulesByKey,
  teamsByKey,
  teams,
  resultSpotsAll,
  divisionsObject,
  bracketsByKey,
  teamNumber,
) => {
  const poule = poulesByKey[match.poule] || {};
  const teamId = teamNumber === 1 ? match.team1Id : match.team2Id;
  const teamNum = teamNumber === 1 ? match.team1 : match.team2;

  let pouleKeyName = poule.fase;
  if (poule.bracket) {
    let bracket = bracketsByKey[poule.bracket] || {};
    pouleKeyName =
      poule.bracketRound === bracket.size && !bracket.subBracketTo
        ? poule.fase
        : poule.fase + "-" + poule.bracketRound + "-" + poule.bracket;
  }

  // Try getting team from ID first
  if (teamId) {
    return (teamsByKey[teamId] || {}).name || "";
  }

  // Try finding team in teams array
  const team = teams.find(
    (t) =>
      t[`poule${pouleKeyName}`] === match.poule &&
      t[`numInPoule${pouleKeyName}`] === teamNum
  );
  if (team?.name) return team.name;

  // Try getting from result spots
  const resultSpot = resultSpotsAll.find(
    (spot) =>
      spot[`poule${poule.fase}`] === match.poule &&
      spot[`numInPoule${poule.fase}`] === teamNum
  );

  if (resultSpot) {
    return getResultSpotName(
      resultSpot,
      resultSpotsAll,
      poulesByKey,
      divisionsObject
    );
  }

  // Return empty spot as fallback
  return `${languages.structure.emptySpot} ${(Number(teamNum) + 1).toString()}`;
};
